import React from 'react';
import { Box, Toolbar, Typography, Card, CardContent } from '@mui/material';
import EditProfile from './DashboardContentMenus/EditProfile';
import ChangePassword from './DashboardContentMenus/ChangePassword';
import Certificate from './Certificate';
import SendInvitation from './SendInvitation';
import ReferredUsers from './DashboardContentMenus/ReferredUsers';
import VisitingCard from './VisitingCard';
import Dashboard from './DashboardContentMenus/Dashboard';
import GroupCategories from './DashboardContentMenus/GroupCategories';
import OneToOneChat from './DashboardContentMenus/OneToOneChat';
import AppDashboard from './DashboardContentMenus/AppDashboard';
import BPF from './DashboardContentMenus/BPF';
// adjust path if needed


const drawerWidth = 240;

const DashboardContent = ({ selectedMenu, sidebarOpen, selectedGroup, selectedUser, onGroupSelect, onUserSelect, onBackToCategories, onBackToUserList, onMenuSelect }) => {
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        p: 3,
        width: {
          xs: '100%',
          sm: `calc(100% - ${sidebarOpen ? drawerWidth : 0}px)`
        },
        transition: 'width 0.3s',
      }}
      className='mainComponentDashboard'
    >
      <Toolbar />

      {/* <Typography variant="h5" gutterBottom>
        {selectedMenu}
      </Typography> */}

      {/* Direct Content Rendering */}
      {selectedMenu === 'Invited Users' && (
        <Card sx={{ p: 2 }} className='dashboardCard'>
          <CardContent className='pb-16px'>
            <Box sx={{ mx: 'auto' }}>
              <Typography variant="h5" gutterBottom sx={{ mb: 3 }} className='green-title'>
                {selectedMenu}
              </Typography>
              <Dashboard />
            </Box>
          </CardContent>
        </Card>
      )}

      {selectedMenu === 'Edit Profile' && (

        <Card sx={{ p: 2 }} className='dashboardCard'>
          <CardContent className='pb-16px'>
            <Box sx={{ mx: 'auto' }}>
              <Typography variant="h5" gutterBottom sx={{ mb: 3 }} className='green-title'>
                {selectedMenu}
              </Typography>
              <EditProfile />
            </Box>
          </CardContent>
        </Card>
      )}

      {selectedMenu === 'Preview' && (
        <Card sx={{ p: 2 }} className='dashboardCard'>
          <CardContent className='pb-16px'>
            <Box sx={{ mx: 'auto' }}>
              <Typography variant="h5" gutterBottom sx={{ mb: 3 }} className='green-title'>
                {selectedMenu}
              </Typography>
            </Box>
          </CardContent>
        </Card>
      )}

      {selectedMenu === 'Certificate' && (
        <Card sx={{ p: 2 }} className='dashboardCard'>
          <CardContent className='pb-16px'>
            <Box sx={{ mx: 'auto' }}>
              <Typography variant="h5" gutterBottom sx={{ mb: 3 }} className='green-title'>
                {selectedMenu}
              </Typography>
              <Certificate />
            </Box>
          </CardContent>
        </Card>
      )}

      {selectedMenu === 'Visiting Card' && (
        <Card sx={{ p: 2 }} className='dashboardCard'>
          <CardContent className='pb-16px'>
            <Box sx={{ mx: 'auto' }}>
              <Typography variant="h5" gutterBottom sx={{ mb: 3 }} className='green-title'>
                {selectedMenu}
              </Typography>
              <VisitingCard />
            </Box>
          </CardContent>
        </Card>
      )}

      {selectedMenu === 'Send Invitation' && (
        <Card sx={{ p: 2 }} className='dashboardCard'>
          <CardContent className='pb-16px'>
            <Box sx={{ mx: 'auto' }}>
              <Typography variant="h5" gutterBottom sx={{ mb: 0 }} className='green-title'>
                {selectedMenu}
              </Typography>
              <SendInvitation />
            </Box>
          </CardContent>
        </Card>
      )}

      {selectedMenu === 'Billionaires for Peace' && (
        <Card sx={{ p: 2 }} className='dashboardCard'>
          <CardContent className='pb-16px'>
            <Box sx={{ mx: 'auto' }}>
              <Typography variant="h5" gutterBottom sx={{ mb: 3 }} className='green-title'>
                {selectedMenu}
              </Typography>
              <BPF />
            </Box>
          </CardContent>
        </Card>
      )}

      {selectedMenu === 'Group Chat' && (
        <Card sx={{ p: 2 }} className='groupChatCardContent'>
          <CardContent className='groupChatCardContent-inner'>
            <Box sx={{ mx: 'auto' }}>
              <GroupCategories 
                selectedMenu={selectedMenu}
                selectedGroup={selectedGroup}
                onGroupSelect={onGroupSelect}
                onBackToCategories={onBackToCategories}
              />
            </Box>
          </CardContent>
        </Card>
      )}

      {selectedMenu === 'Referrals' && (

        <Card sx={{ p: 2 }} className='dashboardCard'>
          <CardContent className='pb-16px'>
            <Box sx={{ mx: 'auto' }}>
              <Typography variant="h5" gutterBottom sx={{ mb: 3 }} className='green-title'>
                {selectedMenu}
              </Typography>
              <ReferredUsers />
            </Box>
          </CardContent>
        </Card>
      )}

      {selectedMenu === 'Change Password' && (
        <Card sx={{ p: 2 }} className='dashboardCard'>
          <CardContent className='pb-16px'>
            <Box sx={{ mx: 'auto' }}>
              <Typography variant="h5" gutterBottom sx={{ mb: 3 }} className='green-title'>
                {selectedMenu}
              </Typography>

              <ChangePassword />
            </Box>
          </CardContent>
        </Card>
      )}

      {selectedMenu === 'Chat' && (
        <Card sx={{ p: 2 }} className='dashboardCard chatMainCardWindow'>
          <CardContent className='pb-16px'>
            <Box sx={{ mx: 'auto' }}>
              <OneToOneChat 
                selectedUser={selectedUser}
                onUserSelect={onUserSelect}
                onBackToUserList={onBackToUserList}
              />
            </Box>
          </CardContent>
        </Card>
      )}

      {selectedMenu === 'AppDashboard' && (
        <Card sx={{ p: 2 }} className='dashboardCard'>
          <CardContent className='pb-16px'>
            <Box sx={{ mx: 'auto' }}>
              <AppDashboard onMenuSelect={onMenuSelect} />
            </Box>
          </CardContent>
        </Card>
      )}


    </Box>
  );
};

export default DashboardContent;
